
export interface NodeId {
    nodeTag: string;
    nodeUrl: string;
    responsibleNode: string;

}
